import React from 'react';
import CustomModal from '../../../../core/common/customModal';

interface Props {
  show: boolean;
  onHide: () => void;
  videoFile: any | null;
  materialTitle?: string;
}

const VideoPlaybackModal = ({ show, onHide, videoFile, materialTitle }: Props) => {
  if (!videoFile) return null;

  const getVideoUrl = () => {
    // If fileUrl is available, use it directly
    if (videoFile.fileUrl) {
      return videoFile.fileUrl;
    }
    
    // If it's a File object with a URL, use that
    if (videoFile instanceof File) {
      return URL.createObjectURL(videoFile);
    }
    
    return videoFile.fileUrl;
  };

  const formatFileSize = (bytes: number) => {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
  };

  const headerContent = (
    <div className="d-flex align-items-center">
      <i className="ti ti-video me-2 text-primary" />
      {materialTitle || 'Video Playback'}
    </div>
  );

  const bodyContent = (
    <div className="position-relative">
      <video
        controls
        className="w-100"
        style={{ maxHeight: '70vh' }}
        preload="metadata"
        onError={(e) => {
          console.error('Video playback error:', e);
        }}
      >
        <source src={getVideoUrl()} type="video/mp4" />
        <source src={getVideoUrl()} type="video/webm" />
        <source src={getVideoUrl()} type="video/ogg" />
        Your browser does not support the video tag.
      </video>
    </div>
  );

  const footerContent = (
    <div className="d-flex justify-content-between align-items-center w-100">
      <div className="d-flex align-items-center text-muted">
        <i className="ti ti-file me-2" />
        <span className="fs-12">
          {videoFile.originalFileName || videoFile.fileName}
        </span>
        {videoFile.fileSize && (
          <span className="ms-2 fs-12">
            ({formatFileSize(videoFile.fileSize)})
          </span>
        )}
      </div>
      
      <div className="d-flex gap-2">
        <button
          className="btn btn-outline-secondary btn-sm"
          onClick={() => {
            const link = document.createElement('a');
            link.href = getVideoUrl();
            link.download = videoFile.originalFileName || videoFile.fileName;
            link.click();
          }}
        >
          <i className="ti ti-download me-1" />
          Download
        </button>
        
        <button
          className="btn btn-primary btn-sm"
          onClick={onHide}
        >
          <i className="ti ti-x me-1" />
          Close
        </button>
      </div>
    </div>
  );

  return (
    <CustomModal
      show={show}
      onClose={onHide}
      headerContent={headerContent}
      bodyContent={bodyContent}
      footerContent={footerContent}
      size="lg"
      zindex={99999}
      backdrop="static"
      headerClassName="text-dark fs-16 fw-bold"
    />
  );
};

export default VideoPlaybackModal;
